import React from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { ComposerEmptyState, ComposerEyebrow, ComposerPanel, ComposerPanelHeader, ComposerPanelTitle } from './composerWorkspace';

const Description = styled.p`
    max-width: 220px;
    margin: 0;
`;

const PrintingEditor: React.FC = () => (
    <ComposerPanel>
        <ComposerPanelHeader>
            <ComposerPanelTitle>
                <ComposerEyebrow>{T._('Printing', 'Admin')}</ComposerEyebrow>
            </ComposerPanelTitle>
        </ComposerPanelHeader>
        <ComposerEmptyState>
            <Description>{T._('Printing methods will be managed from this section. No printing editor is connected yet.', 'Admin')}</Description>
        </ComposerEmptyState>
    </ComposerPanel>
);

export default PrintingEditor;
